import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Dropdown } from '@components/Form/Autocomplete'
import Button from '@components/Button'
import { Formik, Form, Field } from 'formik'
import PropTypes from 'prop-types'
import './RolloverCreditsForm.sass'

class RolloverCreditsForm extends Component {
  state = {
    contracts: []
  }

  componentDidMount () {
    const { contractStore, contract } = this.props
    contractStore
      .getParentAccountContracts(contract.parentAccountId)
      .then(contracts => {
        this.setState({
          contracts: contracts.filter(c => c.contractTypeId !== 1)
        })
      })
  }

  render () {
    const { contractStore, title } = this.props
    const { contract } = this.props
    const contracts = this.state.contracts.filter(c => c.id !== contract.id)
    return (
      <div className='expert-form'>
        <h1 className='contract-form__title'>{title}</h1>
        <Formik
          initialValues={{ contract: null }}
          render={form => (
            <Form onSubmit={form.handleSubmit}>
              <div className='expert-form__input-group'>
                <label className='expert-form__label'>Credit balance</label>
                <div className='rollover-form__value-wrapper expert-form__input-wrapper'>
                  <span className='rollover-form__credit-balance'>
                    {Number(contract.contractBalance).toFixed(2)}
                  </span>
                  <Field
                    form={form}
                    name='contract'
                    placeholder={`Rollover ${
                      contract.contractBalance < 0 ? 'from' : 'to'
                    }`}
                    itemToString={item => item && item.contractReference}
                    options={contracts}
                    component={Dropdown}
                  />
                </div>
              </div>

              <div className='expert-form__section expert-form__section--buttons'>
                <Button
                  primary
                  submit
                  onClick={this.onSubmit}
                  disabled={form.isSubmitting}
                >
                  {this.props.okText}
                </Button>
                <Button
                  onClick={this.props.modalStore.close}
                  disabled={form.isSubmitting}
                >
                  {this.props.cancelText}
                </Button>
              </div>
            </Form>
          )}
          onSubmit={(values, action) => {
            contractStore
              .rolloverCredits(values.contract)
              .then(this.props.modalStore.close)
          }}
        />
      </div>
    )
  }

  static propTypes = {
    contractStore: PropTypes.object,
    contract: PropTypes.object,
    modalStore: PropTypes.object,
    title: PropTypes.string,
    okText: PropTypes.string,
    cancelText: PropTypes.string
  }

  static defaultProps = {
    hideButtons: true,
    showCloseIcon: false,
    shouldCloseOnOverlayClick: true
  }
}

export default inject('modalStore')(observer(RolloverCreditsForm))
